export { default } from './ArrowLeft'
